import { render, staticRenderFns } from "./altamovimiento.vue?vue&type=template&id=2c2a736c"
import script from "./altamovimiento.vue?vue&type=script&lang=js"
export * from "./altamovimiento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports